<template>
  <div>
    <el-drawer :visible.sync="drawer" :title="`${$t('goodsPage.package.Name')} : ${form.giftRules.skuName}`" direction="rtl" size="600px" :modal-append-to-body="false" :before-close="onCancel">
      <BjDivider v-if="form">{{ $t('goodsPage.package.bindSKU') }}</BjDivider>
      <el-form v-if="drawer" ref="form" :model="form" :rules="rules" :disabled="disabled" label-width="200px">
        <el-form-item :label="$t('goodsPage.package.Method')+':'" prop="packingMethod">
          <BjSelectLov v-model="form.packingMethod" :placeholder="$t('goodsPage.package.Method')" :option-list="MethodOption" @change="changeList"/>
        </el-form-item>
        <el-form-item :label="$t('SelectSKUText')+':'">
          <el-button type="primary" class="main-btn" @click="choseSKU">{{ $t('SelectSKUText') }}</el-button>
        </el-form-item>

        <div style="margin-top:10px;">
          <BjDivider>{{$t('AddInternalRefundOnlyDoc.Product')}}</BjDivider>
          <el-table ref="multipleTable" :data="form.mainSkuList" max-height="460px" style="width: 100%" border>
            <el-table-column type="index" :label="$t('billingPage.index')" align="center" width="60"></el-table-column>
            <el-table-column prop="skuName" :label="$t('goodsPage.skuName')" align="center"></el-table-column>
            <el-table-column prop="skuCode" :label="$t('goodsPage.skuCode')" align="center"></el-table-column>
            <el-table-column prop="barCode" :label="$t('goodsSku.detail.Barcode')" align="center"></el-table-column>
            <el-table-column prop="action" :label="$t('operationText')" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="onDelete(scope.row, scope.$index)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="foot" style="margin-top: 60px;">
          <el-button type="danger" @click="onCancel">{{ $t('cancelText') }}</el-button>
          <el-button :disabled="form.mainSkuList.length==0" type="primary" @click="onComfirm">{{ $t('okText') }}</el-button>
        </div>
      </el-form>
    </el-drawer>

    <BjDialogList ref="dialogList" multiple :config="$BjDialogListConfig.skuDefault('SelectSKUText',{defaultQuery: defaultQuery, columns: columns, search: search, actionApi: actionApi})" @confirm="onAddDialogConfirm" />
   
    <el-dialog :title="$t('goodsPage.package.bindInfo')" :visible.sync="dialogShow" width="500px" :before-close="handleClose">
      <div class="flex-align">
        <div style="font-weight: bold;">
          <div style="margin-top:8px;">{{ $t('goodsPage.package.Method') }} : {{ $t(MethodOption.bjGet(dialogData.packingMethod)) }}</div>
          <div style="margin-top:8px;">{{ $t('goodsPage.package.Name') }} : {{ dialogData.packageName }}</div>
          <div style="margin-top:8px;">{{ $t('goodsPage.skuName') }} : {{ dialogData.skuNames }}</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShow = false">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" @click="goBind()">{{ $t('goodsPage.package.bindSKU') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { promotionApi } from '@/api';
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      drawer: false,
      dialogShow: false,
      MethodOption: [
        { label: this.$t('goodsPage.package.order'), value: 'order' },
        { label: this.$t('goodsPage.package.product'), value: 'product' },
      ],
      form: {
        packingMethod: null,
        giftRules: {
          activityPrice: null,
          fullNum: null,
          giftCondition: null,
          giftNum: null,
          packageType: null,
          salesPrice: null,
          skuCode: null,
          skuName: null,
          tenantId: null,
        },
        mainSkuList: [
          // {
          //   skuName:null,
          //   skuCode:null,
          //   barCode:null,
          //   itemType:null,
          // },
        ],
      },
      defaultQuery: {
        status: [1, 2, 3, 4, 5],
        setFlag: 0,
        itemType: "item",
      },
      rules: {
        packingMethod: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
      },
      dialogData:{},
      orderBindPackageList:[],
      productBindPackageList:[],
    };
  },
  methods: {
    // 获取已绑定数据并回显页面
    getData(){
      promotionApi.packageBindGetSKUCode({packageSkuCode:this.form.giftRules.skuCode}).then(res=>{
        // 根据返回值来回显页面sku列表
        if(res.orderBindPackageList?.length&&!res.productBindPackageList?.length){
          this.form.packingMethod = 'order'
          this.form.mainSkuList = res.orderBindPackageList
        }else if(!res.orderBindPackageList?.length&&res.productBindPackageList?.length){
          this.form.packingMethod = 'product'
          this.form.mainSkuList = res.productBindPackageList
        }else if(res.orderBindPackageList?.length&&res.productBindPackageList?.length){
          this.form.packingMethod = 'order'
          this.form.mainSkuList = res.orderBindPackageList
        }else{
          this.form.packingMethod = null
          this.form.mainSkuList = []
        }
        // 保存一份值用以切换打包方式进行显示sku列表
        this.orderBindPackageList = res.orderBindPackageList || []
        this.productBindPackageList = res.productBindPackageList || []
      })
    },
    // 切换sku列表
    changeList(v){
      if(v == 'order'){
        this.form.mainSkuList = this.orderBindPackageList
      }else if(v == 'product'){
        this.form.mainSkuList = this.productBindPackageList
      }
    },
    // 打开商品弹窗
    choseSKU() {
      this.$refs.dialogList.show();
    },
    // 添加商品
    async onAddDialogConfirm(data) {
      if (!data) return;
      if (this.form.mainSkuList.length > 0) {
        const dataList = data.filter(item => !this.form.mainSkuList.some(v => v.skuCode === item.skuCode)).map(item => {
          return {...item, num: null};
        });
        this.form.mainSkuList = [...this.form.mainSkuList, ...dataList];
      } else {
        this.form.mainSkuList = data.map(item => {
          return {...item, num: null};
        });
      }
    },
    onDelete(row,index){
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      }).then(() => {
        const POST_DATA = {
          bindPackageCode:this.form.giftRules.skuCode,
          bindProductCode:row.skuCode,
          bindType:this.form.packingMethod,
        }
        promotionApi.packageBindDELETESKUCode(POST_DATA).then(res=>{
          if (!res.failed) {
            this.form.mainSkuList.splice(index, 1);
            this.$message.success(this.$t('toast.operationSuccessText'));
          }
        })
      })
      
    },
    hide() {
      this.drawer = false;
      this.dialogShow = false;
      this.from = {
        packingMethod: null,
        giftRules: {},
        mainSkuList: [],
      };
      this.$refs['form'].resetFields();
      this.form.mainSkuList = [];
      this.dialogData = {};
    },
    /** 取消 */
    onCancel() {
      this.hide();
    },
    /** 确定 */
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const formData = this.$lodash.clone(this.form);
          this.dialogData = {
            packingMethod:formData.packingMethod,
            packageName:formData.giftRules.skuName,
            skuNames:formData.mainSkuList.map(e=>e.skuName).join(",")
          }
          this.dialogShow = true
        }
      });
    },
    goBind(){
      const POST_DATA = {
        bindType:this.form.packingMethod,
        giftRules:{
          activityPrice: this.form.giftRules.activityPrice,
          fullNum: this.form.giftRules.fullNum,
          giftCondition: this.form.giftRules.giftCondition,
          giftNum: this.form.giftRules.giftNum,
          packageType: this.form.giftRules.packageType,
          salesPrice: this.form.giftRules.salesPrice,
          skuCode: this.form.giftRules.skuCode,
          skuName: this.form.giftRules.skuName,
          tenantId: this.form.giftRules.tenantId,
        },
        mainSkuList: this.form.mainSkuList.map(({skuName, skuCode, barCode, itemType}) => ({
            skuName,
            skuCode, 
            barCode,
            itemType,
        }))
      }
      promotionApi.packageBindSKU(POST_DATA).then(res=>{
        if (!res.failed) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          this.hide();
          setTimeout(() => {
            this.$emit('reFresh');
          }, 500);
        }
      })
    },
  },
};
</script>
<style lang="scss">
.flex-item {
  width: 200px;
  justify-content: space-between;
  align-items: flex-start;
}
.el-drawer__body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  height: 100%;
}
.el-form {
  flex: 1;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
</style>
